import { Controller } from '@hotwired/stimulus';

export class ClearableController extends Controller {
  static targets = ['control'];
  static values = {
    default: { type: String },
    dispatchEvent: { type: Boolean },
    eventType: {
      default: 'input',
      type: String,
    },
  };

  clear() {
    this.controlTargets.forEach(control => {
      if (
        control.type === 'radio'
        || control.type === 'checkbox'
      ) {
        control.checked = control.value === this.defaultValue;
      } else {
        control.value = this.defaultValue;
      }

      control.dispatchEvent(new Event(this.eventTypeValue));
    });
  }
}
